{
  "tabs": {
    "chat": "Čats",
    "reminders": "Atgādinājumi",
    "calendar": "Kalendārs",
    "settings": "Iestatījumi"
  },
  "common": {
    "cancel": "Atcelt",
    "save": "Saglabāt",
    "confirm": "Apstiprināt",
    "delete": "Dzēst",
    "back": "Atpakaļ",
    "close": "Aizvērt",
    "edit": "Rediģēt",
    "search": "Meklēt",
    "all": "Visi",
    "loading": "Ielādē...",
    "error": "Radās kļūda",
    "notFound": "Nav atrasts",
    "tryAgain": "Lūdzu, mēģiniet vēlreiz",
    "retry": "Mēģināt vēlreiz",
    "undo": "Atsaukt",
    "pullToRefresh": "Pavelc, lai atsvaidzinātu",
    "justNow": "tikko"
  },
  "auth": {
    "welcome": "Laipni lūdzam FishMemory",
    "tagline": "Jūsu WhatsApp atgādinājumu asistents, tagad kabatā.",
    "subtitle": "Jūsu WhatsApp atgādinājumu asistents, tagad kabatā.",
    "phoneLabel": "Jūsu WhatsApp numurs",
    "phoneHint": "Nosūtīsim verifikācijas kodu caur WhatsApp",
    "invalidPhone": "Lūdzu, ievadiet derīgu tālruņa numuru",
    "continue": "Turpināt",
    "enterPhone": "Ievadiet savu WhatsApp numuru",
    "phonePlaceholder": "Tālruņa numurs",
    "sendCode": "Nosūtīt kodu",
    "verifyTitle": "Apstipriniet savu numuru",
    "otpSentTo": "6 ciparu kods nosūtīts uz {{phone}} caur WhatsApp",
    "enterFullCode": "Lūdzu, ievadiet visus 6 ciparus",
    "invalidOtp": "Nederīgs kods. Lūdzu, mēģiniet vēlreiz.",
    "otpFailed": "Neizdevās nosūtīt kodu. Mēģiniet vēlreiz.",
    "otpResent": "Kods nosūtīts atkārtoti",
    "resendIn": "Atkārtoti nosūtīt pēc {{seconds}}s",
    "resendCode": "Nosūtīt kodu atkārtoti",
    "enterOtp": "Ievadiet kodu, kas nosūtīts uz jūsu WhatsApp",
    "verify": "Apstiprināt",
    "resend": "Nosūtīt kodu atkārtoti",
    "wrongNumber": "Nepareizs numurs?",
    "backToPhone": "Atpakaļ uz tālruni",
    "editPhone": "Rediģēt tālruņa numuru",
    "error": "Kļūda",
    "setupTitle": "Iestatīsim visu",
    "setupSubtitle": "Šos iestatījumus varēsiet mainīt vēlāk Iestatījumos",
    "namePlaceholder": "Jūsu vārds",
    "letsGo": "Pabeigt iestatīšanu",
    "skipForNow": "Izlaist uz laiku"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "Rakstiet ziņu...",
    "inputPlaceholder": "Rakstiet ziņu...",
    "typing": "FishMemory raksta...",
    "online": "Tiešsaistē",
    "connecting": "Savienojas...",
    "reconnecting": "Pieslēdzas atkārtoti...",
    "offline": "Bezsaistē",
    "empty": "Sāciet sarunu",
    "emptyHint": "Izveidojiet atgādinājumus, pārbaudiet grafiku vai lūdziet palīdzību.",
    "emptyAction": "Nosūtīt parauga atgādinājumu",
    "actions": "Čata darbības",
    "keep": "Saglabāt ziņas",
    "clearTitle": "Notīrīt čatu",
    "clearConfirm": "Dzēst visas ziņas no šīs ierīces? To nevar atsaukt.",
    "clear": "Notīrīt čatu",
    "optionSelected": "Izvēlēts: {{label}}",
    "sendingSelection": "Sūta...",
    "connectionLost": "Pieslēgšanās atkārtota..."
  },
  "reminders": {
    "title": "Mani atgādinājumi",
    "active": "Aktīvi",
    "today": "Šodien",
    "thisWeek": "Šonedēļ",
    "history": "Vēsture",
    "items": "vienības",
    "emptyTitle": "Vēl nav atgādinājumu",
    "emptySubtitle": "Izveidojiet no čata, un tas parādīsies šeit.",
    "emptyAction": "Atvērt čatu",
    "filterActive": "Aktīvi",
    "filterToday": "Šodien",
    "filterWeek": "Šonedēļ",
    "filterHistory": "Vēsture",
    "emptyState": "Vēl nav atgādinājumu. Sāciet sarunu!",
    "swipeDone": "Pabeigts",
    "swipeSnooze": "Atlikt",
    "swipeDelete": "Dzēst",
    "search": "Meklēt atgādinājumus...",
    "upcoming": "Drīzumā",
    "completed": "Pabeigti",
    "overdue": "Aizkavējušies",
    "tomorrow": "Rīt",
    "synced": "Sinhronizēts {{value}}",
    "swipeHint": "Pavelciet atgādinājumu, lai redzētu vairāk darbību",
    "noResults": "Nav atgādinājumu, kas atbilst meklēšanai",
    "noResultsHint": "Mēģiniet citu atslēgvārdu vai notīriet meklēšanu",
    "deleteAllFailed": "Neizdevās dzēst visus atgādinājumus"
  },
  "calendar": {
    "title": "Kalendārs",
    "today": "Šodien",
    "tomorrow": "Rīt",
    "completed": "pabeigts",
    "noEvents": "Nav plānoto notikumu",
    "noEventsSubtitle": "Izvēlieties datumu, lai redzētu atgādinājumus un kalendāra notikumus.",
    "googleEvent": "Google Kalendārs",
    "legendActive": "Aktīvs",
    "legendRecurring": "Atkārtojas",
    "legendDone": "Pabeigts",
    "legendGoogle": "Google",
    "previousMonth": "Iepriekšējais mēnesis",
    "nextMonth": "Nākamais mēnesis",
    "previousYear": "Iepriekšējais gads",
    "nextYear": "Nākamais gads",
    "goToToday": "Doties uz šodienu",
    "all": "Visi",
    "active": "Aktīvi",
    "done": "Pabeigti",
    "paused": "Pauzēti"
  },
  "settings": {
    "title": "Iestatījumi",
    "profile": "Profils",
    "name": "Parādāmais vārds",
    "enterName": "Ievadiet savu vārdu",
    "language": "Valoda",
    "uiLanguage": "Lietotnes valoda",
    "uiLanguageHelp": "Maina lietotnes saskarni, kalendāra etiķetes un izkārtojuma virzienu tikai šajā ierīcē.",
    "serverLanguage": "Čata valoda",
    "serverLanguageHelp": "Maina valodu, ko izmanto servera atbildēs un atgādinājumu ziņojumos jūsu kontam.",
    "timezone": "Laika josla",
    "currentTimezone": "Pašreizējā laika josla",
    "timezoneHelp": "Visi atgādinājumu laiki tiek rādīti, izmantojot šo laika joslu.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "Saglabāt laika joslu",
    "timezoneSaved": "Laika josla atjaunināta",
    "detect": "Noteikt",
    "detectFailed": "Neizdevās noteikt laika joslu",
    "autoDetect": "Automātiska noteikšana no GPS",
    "notifications": "Paziņojumi",
    "notificationsHelp": "Atkārtotie atgādinājumi kontrolē atkārtotus brīdinājumus pēc atgādinājuma saņemšanas. Ierīces līmeņa paziņojumu atļaujas joprojām tiek pārvaldītas tālruņa iestatījumos.",
    "pushEnabled": "Push paziņojumi",
    "autoDoneOnFire": "Automātiski atzīmēt kā izpildītu, kad izpildīts",
    "autoDoneOnFireDesc": "Ja izslēgts, atgādinājumi paliek aktīvi, līdz tos atzīmējat kā izpildītus.",
    "googleCalendar": "Google Kalendārs",
    "google": "Google Kalendārs",
    "googleConnected": "Savienots",
    "googleDisconnected": "Nav savienots",
    "googleConnectedHelp": "Jauni atgādinājumi var tikt automātiski sinhronizēti ar jūsu kalendāru.",
    "googleDisconnectedHelp": "Savienojiet Google Kalendāru, lai atgādinājumi un notikumi būtu saskaņoti.",
    "googleConnectFailed": "Neizdevās savienot Google Kalendāru",
    "connected": "Savienots",
    "disconnected": "Nav savienots",
    "connect": "Savienot",
    "disconnect": "Atvienot",
    "autoSync": "Automātiska jauno atgādinājumu sinhronizācija",
    "autosync": "Automātiska jauno atgādinājumu sinhronizācija",
    "subscription": "Abonements",
    "trialUsed": "Pārbaude: {{used}}/{{total}} izmantots",
    "trialStatus": "Pārbaude pieejama",
    "activeStatus": "Aktīvs abonements",
    "expiredStatus": "Abonements beidzies",
    "unsubscribedStatus": "Nav abonēts",
    "about": "Par",
    "version": "Versija",
    "logout": "Iziet",
    "logoutTitle": "Iziet",
    "logoutConfirm": "Vai tiešām vēlaties iziet?",
    "noName": "Vārds nav iestatīts",
    "serverConnection": "Savienojums ar serveri",
    "serverUrl": "Servera URL",
    "serverEdit": "Rediģēt",
    "saveReconnect": "Saglabāt un pieslēgties atkārtoti",
    "resetDefault": "Atjaunot noklusējumu",
    "invalidServerUrlTitle": "Nederīgs servera URL",
    "invalidServerUrlMessage": "Ievadiet derīgu http vai https servera URL, piemēram, https://example.com",
    "uiLanguageChangeFailed": "Neizdevās mainīt lietotnes valodu. Lūdzu, mēģiniet vēlreiz.",
    "serverLanguageChangeFailed": "Neizdevās mainīt čata valodu. Lūdzu, mēģiniet vēlreiz.",
    "timezoneChangeFailed": "Neizdevās mainīt laika joslu. Lūdzu, mēģiniet vēlreiz.",
    "autoSyncChangeFailed": "Neizdevās atjaunināt automātisko sinhronizāciju. Lūdzu, mēģiniet vēlreiz.",
    "nameChangeFailed": "Neizdevās atjaunināt parādāmo vārdu. Lūdzu, mēģiniet vēlreiz.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "Atgādinājuma detaļas",
    "editTime": "Rediģēt laiku",
    "rename": "Pārsaukt",
    "snooze": "Atlikt",
    "snooze15": "Atlikt par 15 minūtēm",
    "pause": "Pauzēt",
    "pauseReminder": "Pauzēt atgādinājumu",
    "resume": "Turpināt",
    "resumeReminder": "Turpināt atgādinājumu",
    "skip": "Izlaist nākamo",
    "skipOccurrence": "Izlaist šo reizi",
    "syncGoogle": "Sinhronizēt ar Google",
    "delete": "Dzēst",
    "deleteTitle": "Dzēst atgādinājumu",
    "deleteConfirm": "Šis atgādinājums tiks neatgriezeniski dzēsts.",
    "deleteRecurringTitle": "Dzēst atkārtotu atgādinājumu",
    "deleteRecurringMessage": "Vai vēlaties izlaist šo reizi vai dzēst visu sēriju?",
    "deleteThisOccurrence": "Izlaist šo reizi",
    "deleteEntireSeries": "Dzēst visu sēriju",
    "done": "Pabeigts",
    "markDone": "Atzīmēt kā pabeigtu",
    "undo": "Atjaunot",
    "undoPrompt": "Jābūt atkal aktīvam? Atjaunojiet to tagad.",
    "recurring": "Atkārtots",
    "nextRun": "Nākamā reize",
    "oneTime": "Vienreizējs",
    "pending": "Gaida",
    "sent": "Nosūtīts",
    "paused": "Pauzēts",
    "active": "Aktīvs",
    "snoozed": "Atlikts",
    "localTime": "Rādīts jūsu vietējā laikā",
    "recurrence": "Atkārtošanās",
    "created": "Izveidots",
    "tags": "Birkas",
    "fireCount": "Reizes izpildīts",
    "actions": "Darbības",
    "none": "Nav",
    "snoozeFailed": "Neizdevās atlikt atgādinājumu",
    "pauseFailed": "Neizdevās pauzēt atgādinājumu",
    "resumeFailed": "Neizdevās turpināt atgādinājumu",
    "skipFailed": "Neizdevās izlaist atgādinājumu",
    "doneFailed": "Neizdevās atzīmēt atgādinājumu kā pabeigtu",
    "undoFailed": "Neizdevās atjaunot atgādinājuma statusu",
    "deleteFailed": "Neizdevās dzēst atgādinājumu",
    "rescheduleTitle": "Pārcelt laiku?",
    "rescheduleMsg": "Šis atgādinājums ir nokavēts. Vai vēlaties to pārcelt?",
    "reschedule15": "Pēc 15 minūtēm",
    "reschedule60": "Pēc 1 stundas",
    "keepOverdue": "Atstāt kā ir"
  },
  "onboarding": {
    "slide1Title": "Laipni lūdzam FishMemory",
    "slide1Sub": "Jūsu personīgais atgādinājumu asistents — darbina WhatsApp un veidots jūsu kabatai.",
    "slide2Title": "Vienkārši rakstiet dabiski",
    "slide2Sub": "Rakstiet atgādinājumus tā, kā domājat: “Atgādini man piezvanīt mammai rīt plkst. 15:00” — mēs parūpēsimies par pārējo.",
    "slide3Title": "Nekad neko nepalaidiet garām",
    "slide3Sub": "Saņemiet savlaicīgus paziņojumus, organizējiet ar birkām un sekojiet visam svarīgajam.",
    "getStarted": "Sākt",
    "next": "Tālāk",
    "firstReminderTitle": "Izveidojiet savu pirmo atgādinājumu!",
    "firstReminderHint": "Mēģiniet ierakstīt kaut ko līdzīgu:",
    "firstReminderExample": "Atgādini man dzert ūdeni rīt plkst. 9:00",
    "gotIt": "Saprotu!",
    "notifRationaleTitle": "Esi laikā",
    "notifRationaleBody": "FishMemory nepiecieš paziņojumus, lai atgādinātu laikā. Jūs saņemsiet brīdinājumus tikai par izveidotajiem atgādinājumiem.",
    "notifRationaleAllow": "Ieslēgt paziņojumus",
    "notifRationaleLater": "Varbūt vēlāk",
    "swipeHint": "Pavelciet pa labi ātrām darbībām →",
    "calendarDragHint": "Velciet, lai paplašinātu ↕"
  }
}
